import * as validation from '../../../validation/validation-controller';
import BaseView from '../../../pages/myAccount/profile/BaseView';
import ChangeListOfAddressesView from '../../../pages/myAccount/profile/ChangeListOfAddressesView';
import PersonalInformationBusinessCustomerView from '../../../pages/myAccount/profile/PersonalInformationBusinessCustomerView';
import PersonalInformationView from '../../../pages/myAccount/profile/PersonalInformationView';
import PasswordQualityView from '../../../layout/PasswordQualityView';

export default BaseView.extend({

    events: {
        'click #myaccount-change-pswd-btn': 'onChangePasswordButtonClick',
        'click #myaccount-personal-info-btn': 'onChangePersonalInfoButtonClick',
        'click #myaccount-list-addresses-btn': 'onChangeListOfAddressesButtonClick'
    },

    lightboxesConfig: {
        changePasswordLightbox: {
            selector: '.js-password-lightbox',
            className: 'myaccount-pswd-lightbox-spacer',
            viewClass: PasswordQualityView
        },
        changePersonalInfoLightbox: {
            selector: '#details-lightbox',
            className: 'myaccount-personal-details-lightbox-spacer',
            viewClass: $('#details-lightbox').find('.js-b2b-form').length
                ? PersonalInformationBusinessCustomerView
                : PersonalInformationView
        },
        changeListOfAddressesLightbox: {
            selector: '#list-addresses-lightbox',
            className: 'myaccount-addresslist-lightbox-spacer',
            viewClass: ChangeListOfAddressesView
        }
    },

    initialize: function () {
        if (window.location.hash === '#edit.data') {
            this.openLightboxByName('changePersonalInfoLightbox');
        }

        if (window.location.hash === '#address.book') {
            this.openLightboxByName('changeListOfAddressesLightbox');
        }
    },

    onChangePasswordButtonClick: function (event) {
        event.preventDefault();
        this.openLightboxByName('changePasswordLightbox', $.proxy(validation.reload, validation));
    },

    onChangePersonalInfoButtonClick: function (event) {
        event.preventDefault();
        this.openLightboxByName('changePersonalInfoLightbox');
    },

    onChangeListOfAddressesButtonClick: function (event) {
        event.preventDefault();
        this.openLightboxByName('changeListOfAddressesLightbox');
    }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/myAccount/profile/MainView.js
 **/